import { ComponentPropsWithRef } from 'react';
import { cn } from '@/shared/lib/cn';
import './tabs.scss';

type Props = ComponentPropsWithRef<'button'>;
export const TabsTab = ({ children, onMouseDown, onFocus, className, ...props }: Props) => {
    return (
        <button
            type="button"
            onMouseDown={(e) => {
                onMouseDown?.(e);
                (e.target as HTMLButtonElement).scrollIntoView({
                    behavior: 'smooth',
                    block: 'nearest',
                });
            }}
            onFocus={(e) => {
                // Is focused by mouse
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                if ((e.nativeEvent as { sourceCapabilities?: Record<string, any> }).sourceCapabilities) {
                    return;
                }
                (e.target as HTMLButtonElement).scrollIntoView({ behavior: 'smooth', block: 'nearest' });
                onFocus?.(e);
            }}
            data-testid="tabs-tab"
            className={cn('tabs__tab', className)}
            {...props}
        >
            {children}
        </button>
    );
};
